export enum SubmitAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  None = 'none'
}
